import { render } from "./ExtendP2PTimer.vue?vue&type=template&id=6538b2b2"
import script from "./ExtendP2PTimer.vue?vue&type=script&lang=js"
export * from "./ExtendP2PTimer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__